import { RichTextEditor as MantineRichTextEditor, RichTextEditorToolbarProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";

/**
 * Toolbar wrapper. Applies the EdgeTier toolbar styling (transparent background, default border + gap) via className so
 * the rule wins regardless of how Mantine internally resolves compound classNames.
 */
export const Toolbar: FunctionComponent<RichTextEditorToolbarProps> = ({ className, ...other }) => (
    <MantineRichTextEditor.Toolbar className={clsx(styles["toolbar"], className)} {...other} />
);

Toolbar.displayName = "RichTextEditor.Toolbar";
